import { render, staticRenderFns } from "./RoleFeatures.vue?vue&type=template&id=5dbb278a&scoped=true"
import script from "./RoleFeatures.vue?vue&type=script&lang=js"
export * from "./RoleFeatures.vue?vue&type=script&lang=js"
import style0 from "./RoleFeatures.vue?vue&type=style&index=0&id=5dbb278a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbb278a",
  null
  
)

export default component.exports